module.exports = __webpack_public_path__ + "static/media/insurgentes.481a7e78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/centers/insurgentes.png
// module id = 618
// module chunks = 0